// extracted by mini-css-extract-plugin
export default {"container":"RdKld","error":"chCB6","maxAds":"JQyIG"};